// Basic idea from: https://blog.corsego.com/stimulus-count-characters-in-input-field

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [ "name", "counter" ]

  nameTargetConnected(_) {
    if (this.counterTarget) {
        this.countCharacters();
    }
  }

  counterTargetConnected(_) {
    if (this.nameTarget) {
        this.countCharacters();
    }
  }

  countCharacters(_) {
    const characters = this.nameTarget.value.length;
    this.counterTarget.innerText = characters;
  }
}
